import { render, staticRenderFns } from "./TextWithLeftImage.vue?vue&type=template&id=51bdb086&scoped=true&lang=pug&"
import script from "./TextWithLeftImage.vue?vue&type=script&lang=js&"
export * from "./TextWithLeftImage.vue?vue&type=script&lang=js&"
import style0 from "./TextWithLeftImage.vue?vue&type=style&index=0&id=51bdb086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bdb086",
  null
  
)

export default component.exports